// Complementary Products Component - Vanilla JS + Swiper
// Converted from jQuery/Slick to vanilla JS/Swiper

if (typeof complementaryProductsComponent === 'undefined')
{
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const url = this.dataset.url;
            this.buildProducts(url);
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();

                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div').replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;

                const recommendations = html.querySelector('[data-complementary-product]');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;

                    if (window.sharedFunctions && window.sharedFunctions.checkNeedToConvertCurrency()) {
                        const currencyEl = document.querySelector('#currencies .active');
                        const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                        if (currencyCode) {
                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                }

                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);

                if (typeof Fancybox !== 'undefined') {
                    const isCartTemplate = document.body.classList.contains("template-cart");
                    Fancybox.bind("[data-fancybox*='upsell']", {
                        dragToClose: false,
                        parentEl: isCartTemplate
                          ? document.querySelector(`body`)
                          : document.querySelector(".halo-cart-sidebar"),
                        closeButton: false,
                    });
                }
            }

            fetchProducts(url);
        }

        initializeSlider(productCarousel = null) {
            if (!productCarousel) return;

            // Check if Slick is already initialized (avoid conflict)
            if (productCarousel.classList.contains('slick-initialized')) {
                // console.log('Complementary products carousel already using Slick, skipping Swiper initialization');
                return;
            }

            // Check if already initialized
            if (productCarousel.classList.contains('swiper-initialized')) {
                return;
            }

            const itemArrows = productCarousel.dataset.itemArrows === 'true';
            const itemDots = productCarousel.dataset.itemDots === 'true';
            const itemRows = parseInt(productCarousel.dataset.itemRows) || 1;
            const itemToShow = parseInt(productCarousel.dataset.itemToShow) || 1;
            const complementaryStyle = this.classList.contains('style-1');

            // Validate Swiper structure
            let wrapper = productCarousel.querySelector('.swiper-wrapper');
            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.className = 'swiper-wrapper';

                const slides = productCarousel.querySelectorAll('.product, .swiper-slide, > *');
                slides.forEach(slide => {
                    if (!slide.classList.contains('swiper-slide')) {
                        slide.classList.add('swiper-slide');
                    }
                    wrapper.appendChild(slide);
                });

                productCarousel.appendChild(wrapper);

                if (itemDots) {
                    const pagination = document.createElement('div');
                    pagination.className = 'swiper-pagination';
                    productCarousel.appendChild(pagination);
                }
            }

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper is not loaded yet');
                return;
            }

            const slidesToShow = complementaryStyle ? itemToShow : 1;

            // Get navigation buttons
            const nextBtn = productCarousel.querySelector('.swiper-button-next');
            const prevBtn = productCarousel.querySelector('.swiper-button-prev');

            // Add SVG icons to buttons if available
            if (window.arrows && itemArrows) {
                if (nextBtn && window.arrows.icon_next) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = window.arrows.icon_next;
                    const iconSvg = tempDiv.querySelector('svg');
                    if (iconSvg) {
                        nextBtn.innerHTML = '';
                        nextBtn.appendChild(iconSvg.cloneNode(true));
                    }
                }
                if (prevBtn && window.arrows.icon_prev) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = window.arrows.icon_prev;
                    const iconSvg = tempDiv.querySelector('svg');
                    if (iconSvg) {
                        prevBtn.innerHTML = '';
                        prevBtn.appendChild(iconSvg.cloneNode(true));
                    }
                }
            }

            const swiper = new Swiper(productCarousel, {
                slidesPerView: slidesToShow,
                slidesPerGroup: 1,
                spaceBetween: 0,
                loop: false,
                rtl: window.rtl_slick || false,
                navigation: (itemArrows && nextBtn && prevBtn) ? {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                } : false,
                pagination: itemDots ? {
                    el: productCarousel.querySelector('.swiper-pagination'),
                    clickable: true,
                } : false,
                breakpoints: {
                    1025: {
                        slidesPerView: complementaryStyle ? 2 : 1,
                    },
                    992: {
                        slidesPerView: complementaryStyle ? 2 : 1,
                    },
                    768: {
                        slidesPerView: complementaryStyle ? 2 : 1,
                    },
                    321: {
                        slidesPerView: 1,
                    }
                },
                on: {
                    init: () => {
                        this.calculateCard06Padding();
                    }
                }
            });

            productCarousel.classList.add('swiper-initialized');
            productCarousel.swiperInstance = swiper;
        }

        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const cardAction = this.querySelector('.product .card-action');
            const swiperWrapper = this.querySelector('.swiper-wrapper');
            if (cardAction && swiperWrapper) {
                const selectOptionsHeight = cardAction.scrollHeight;
                swiperWrapper.style.paddingBottom = selectOptionsHeight + 'px';
            }
        }
    }

    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    })

    var complementaryProductsComponent = ComplementaryProductsComponent;
}
